"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M6.075 21.513a3.638 3.638 0 0 1-2.423.922A3.656 3.656 0 0 1 0 18.783a3.66 3.66 0 0 1 2.258-3.376A9.926 9.926 0 0 1 8.352 4.344 3.656 3.656 0 0 1 12 .522a3.656 3.656 0 0 1 3.648 3.822 9.933 9.933 0 0 1 6.094 11.063A3.658 3.658 0 0 1 24 18.783a3.656 3.656 0 0 1-3.652 3.652 3.637 3.637 0 0 1-2.423-.921A9.937 9.937 0 0 1 12 23.477a9.936 9.936 0 0 1-5.925-1.965Zm.675-.798a8.89 8.89 0 0 0 5.25 1.72c1.89 0 3.735-.607 5.25-1.72a3.63 3.63 0 0 1-.554-1.932 3.656 3.656 0 0 1 4.032-3.633 8.887 8.887 0 0 0-5.284-9.76A3.658 3.658 0 0 1 12 7.825 3.658 3.658 0 0 1 8.556 5.39a8.877 8.877 0 0 0-5.286 9.76 3.656 3.656 0 0 1 4.033 3.632 3.63 3.63 0 0 1-.554 1.933ZM9.423 4.583A2.613 2.613 0 0 0 12 6.783a2.612 2.612 0 0 0 2.609-2.61A2.612 2.612 0 0 0 12 1.566a2.612 2.612 0 0 0-2.577 3.018Zm8.905 15.849a.537.537 0 0 1 .076.089c.478.534 1.173.87 1.944.87a2.612 2.612 0 0 0 2.608-2.608 2.613 2.613 0 0 0-1.901-2.512.464.464 0 0 1-.101-.026 2.612 2.612 0 0 0-3.215 2.538c0 .625.221 1.2.589 1.649ZM3.652 16.174a2.612 2.612 0 0 0-2.609 2.609 2.612 2.612 0 0 0 2.61 2.608 2.612 2.612 0 0 0 2.608-2.608 2.612 2.612 0 0 0-2.609-2.61Z",
    clipRule: "evenodd"
  })]
});